// extracted by mini-css-extract-plugin
export default {"similarProductBox":"SimilarProduct_similarProductBox__bIqgs","availSizeTitle":"SimilarProduct_availSizeTitle__47lbn","smallTitle":"SimilarProduct_smallTitle__abrOi"};